import viewport from "./viewport";
import lockScroll from "./lock-scroll";
import './form-styler';
import Swiper from "swiper";

export default function () {

    function initCatalogFilter() {

        let showFilter = document.getElementsByClassName('js-show-filter');
        let catalogFilter = document.getElementsByClassName('catalog-filter');
        let filterSelect = document.getElementsByClassName('filter-select__name');
        let filterSelectItems = document.getElementsByClassName('filter-select');
        let closeFilter = document.getElementsByClassName('js-close-filter');
        let adaptiveTitle = document.getElementsByClassName('catalog-filter-modals__title');

        if(catalogFilter.length>0) {

            Array.from(showFilter).forEach(button => button.addEventListener('click', function (e) {
                if (document.body.classList.contains('filter-opened')) {
                    lockScroll(0);
                    document.body.classList.remove('filter-opened');
                    document.body.classList.remove('filter-lvl2-opened');
                    Array.from(filterSelectItems).forEach(function (item) {
                        item.classList.remove('is-opened');
                    });
                }
                else {
                    lockScroll(1);
                    document.body.classList.add('filter-opened');
                }
                e.preventDefault();
            }));


            Array.from(closeFilter).forEach(button => button.addEventListener('click', function (e) {
                lockScroll(0);
                document.body.classList.remove('filter-opened');
                document.body.classList.remove('filter-lvl2-opened');
                Array.from(filterSelectItems).forEach(function (item) {
                    item.classList.remove('is-opened');
                });
                e.preventDefault();
            }));

            let checkListBtn = document.getElementsByClassName('checkbox-list-more');

            Array.from(checkListBtn).forEach(button => button.addEventListener('click', function (e) {

                this.style.display = 'none';

                let currentList = this.previousElementSibling;

                let hiddenCheckboxes = currentList.getElementsByClassName('checkbox-list__item--hidden');

                Array.from(hiddenCheckboxes).forEach(function (checkbox) {
                    checkbox.classList.remove('checkbox-list__item--hidden');
                });

                e.preventDefault();
            }));



            Array.from(filterSelect).forEach(button => button.addEventListener('click', function (e) {

                if(this.parentElement.classList.contains('is-opened')){
                    this.parentElement.classList.toggle('is-opened');
                }
                else{
                    Array.from(filterSelectItems).forEach(function (item) {
                        item.classList.remove('is-opened');
                    });
                    this.parentElement.classList.add('is-opened');
                }

                if(viewport().width < 765) {
                    document.body.classList.add('filter-lvl2-opened');
                }

                e.preventDefault();
            }));

            document.body.addEventListener("click", function(e) {
                if(viewport().width > 765) {
                    let elm = e.target;
                    while (elm !== document.body) {
                        if (/(?:^| )filter-select(?:$| )/.test(elm.className)) {
                            return;
                        }
                        elm = elm.parentNode;
                    }

                    Array.from(filterSelectItems).forEach(function (item) {
                        item.classList.remove('is-opened');
                    });
                }
            });


            Array.from(adaptiveTitle).forEach(button => button.addEventListener('click', function (e) {

                document.body.classList.remove('filter-lvl2-opened');

                Array.from(filterSelectItems).forEach(function (item) {
                    item.classList.remove('is-opened');
                });
                e.preventDefault();
            }));



            $('.js-custom-select').styler();


            let fixedLine = document.getElementsByClassName('catalog-filter')[0];
            let fixedLineTop = 0;
            document.body.classList.remove('catalog-fixed');

            if(fixedLine){
                fixedLineTop = fixedLine.offsetTop;
            }

            function checkFixed() {
                if(!window.scrollLocked && viewport().width > 765) {
                    let windTop = window.scrollY;
                    if (windTop > fixedLineTop - 70) {
                        document.body.classList.add('catalog-fixed');

                    }
                    else {
                        document.body.classList.remove('catalog-fixed');
                    }
                }
            }

            window.addEventListener('scroll', function() {
                checkFixed();
            });

            window.addEventListener('resize', function() {
                if(fixedLine && !window.scrollLocked){
                    document.body.classList.remove('catalog-fixed');
                    fixedLineTop = fixedLine.offsetTop;
                    checkFixed();
                }
            });

            window.addEventListener('load', function() {
                if(fixedLine && !window.scrollLocked){
                    document.body.classList.remove('catalog-fixed');
                    fixedLineTop = fixedLine.offsetTop;
                    checkFixed();
                }
            });



            let mobileFilterBtn  = document.getElementsByClassName('catalog-filter-btn')[0];

            if(mobileFilterBtn) {
                let catalogGrid = document.getElementsByClassName('catalog-grid')[0];
                let catalogGridTop = catalogGrid.offsetTop;

                let pageFooter = document.getElementsByClassName('page-footer')[0];
                let pageFooterTop = pageFooter.offsetTop - viewport().height;

                window.addEventListener('scroll', function () {
                    let windTop = window.scrollY;

                    if (windTop > catalogGridTop && windTop < pageFooterTop) {
                        mobileFilterBtn.classList.add('is-visible');
                    }
                    else{
                        mobileFilterBtn.classList.remove('is-visible');
                    }

                });
            }



            checkFixed();

        }

    }


    initCatalogFilter();


}
